var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E42375"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.1667V21C13.5 21.663 13.7634 22.2989 14.2322 22.7678C14.7011 23.2366 15.337 23.5 16 23.5C16.663 23.5 17.2989 23.2366 17.7678 22.7678C18.2366 22.2989 18.5 21.663 18.5 21V20.1667M23.5 11.6058C22.9534 10.4169 22.1596 9.35808 21.1717 8.5M8.5 11.6058C9.04612 10.417 9.83929 9.35825 10.8267 8.5M14.3333 10.1667C14.3333 9.72464 14.5089 9.30072 14.8215 8.98816C15.134 8.67559 15.558 8.5 16 8.5C16.442 8.5 16.866 8.67559 17.1785 8.98816C17.4911 9.30072 17.6667 9.72464 17.6667 10.1667C18.6237 10.6192 19.4395 11.3236 20.0267 12.2044C20.6139 13.0852 20.9504 14.1092 21 15.1667V17.6667C21.0627 18.1848 21.2462 18.6809 21.5357 19.1151C21.8252 19.5493 22.2126 19.9095 22.6667 20.1667H9.33333C9.78745 19.9095 10.1748 19.5493 10.4643 19.1151C10.7538 18.6809 10.9373 18.1848 11 17.6667V15.1667C11.0496 14.1092 11.3861 13.0852 11.9733 12.2044C12.5605 11.3236 13.3763 10.6192 14.3333 10.1667Z",
    stroke: "#E42375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6216809a2a1207eec9eb749575ffca1e.svg";
export { ForwardRef as ReactComponent };